//master controller
import { ModalController } from './ModalController.js';
//generic controller
import { AlertModalController } from './Generic/Controller/AlertModalController.js';
import { ConfirmModalController } from './Generic/Controller/ConfirmModalController.js';
import { LoadingModalController } from './Generic/Controller/LoadingModalController';
import { SuccessModalController } from './Generic/Controller/SuccessModalController.js';
//authen controller
import { OtpModalController } from './Authen/Controller/OtpModalController.js';
//redeem controller
import { ConfirmRedeemModalController } from './Redeem/Controller/ConfirmRedeemModalController.js';
import { DrawDeliveryModalController } from './Redeem/Controller/DrawDeliveryModalController.js';
import { SerialModalController } from './Redeem/Controller/SerialModalController.js';
import { ShippingAddressModalController } from './Redeem/Controller/ShippingAddressModalController.js';
import { FreeDeliverySuccessModalController } from './Redeem/Controller/FreeDeliverySuccessModalController.js';
import { ConfirmDeliveryAddressModalController } from './Redeem/Controller/ConfirmDeliveryAddressModalController.js';
// custom modal controller
import { ProductDescriptionModalController } from "./Custom/Controller/ProductDescriptionModalController.js";
import { PointSummaryModalController } from "./Custom/Controller/PointSummaryModalController.js";
import { SkipModalController } from "./Custom/Controller/SkipModalController.js"
import { PointCollectionStepModalController } from "./Custom/Controller/PointCollectionStepModalController.js"
import { WelcomePointModalController } from "./Custom/Controller/WelcomePointModalController.js";
import { PointCollectionModalController } from "./Custom/Controller/PointCollectionModalController.js"
import { AlertRegisterModalController } from './Generic/Controller/AlertRegisterModalController.js';
import { TermModalController } from './Custom/Controller/TermModalController.js';
import { MissionSuccessModalController } from './Custom/Controller/MissionSuccessModalController.js';
import { MissionSuccessCheckinModalController } from './Custom/Controller/MissionSuccessCheckinModalController.js';

import { CancelMemberModalController } from './Custom/Controller/CancelMemberModalController.js';
import { DonateSuccessModalController } from './Redeem/Controller/DonateSuccessModalController.js'
import { MarketingModalController } from './Custom/Controller/MarketingModalController.js';
import { PrivacySettingModalController } from './Custom/Controller/PrivacySettingModalController.js';
import { CopyPersonalModalController } from './Custom/Controller/CopyPersonalModalController.js';
import { TermsRegisterModalController } from './Custom/Controller/TermsRegisterModalController.js';
import { PrivacyRegisterModalController } from './Custom/Controller/PrivacyRegisterModalController.js';
import { AgeConsentAlertModalController } from './Custom/Controller/AgeConsentAlertModalController.js';
import { MarketingReConsentModalController } from './Custom/Controller/MarketingReConsentModalController.js';
import { TermsReConsentModalController } from './Custom/Controller/TermsReConsentModalController.js';
import { PrivacyReConsentModalController } from './Custom/Controller/PrivacyReConsentModalController.js';
import { LeaderBoardConditionModalController } from './Custom/Controller/LeaderBoardConditionModalController.js';
import { WelcomeCouponModalController } from './Custom/Controller/WelcomeCouponModalController.js';
/**
 * Master ontroller
 * @method getModalController
 * Generic controller
 * @method getAlertModal
 * @method getConfirmModal
 * @method getLoadingModal
 * @method getSuccessModal
 * Authen controller
 * @method getOtpModalController
 * Redeem controller
 * @method getConfirmRedeemModal
 * @method getDrawDeliveryModal
 * @method getSerialModal
 * @method getShippingAddressModal
 * @method getFreeDeliverySuccessModal
 * Other
 * @method getWelcomePointModal
 * @method getPointCollectionModal
 * @method getAlertRegisterModal
 * @method getMissionSuccessModal
 * @method getMissionSuccessCheckinModal
 * @method getCancelMemberModal
 * @method getMarketingModal
 * @method getPrivacySettingModal
 * @method getCopyPersonalModal
 * @method getTermsRegisterModal
 * @method getPrivacyRegisterModal
 * @method getAgeConsentAlertModal
 * @method getLeaderBoardConditionModal
 * @method getWelcomeCouponModal
 */
export default function ModalFactory() {
    this.modalController = new ModalController();
    //#region generic
    // groupname
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.successModal = null;
    // group name
    this.confirmRedeemModal = null;
    this.drawDeliveryModal = null;
    this.donateSuccessModal = null;
    this.serialModal = null;
    this.shippingAddressModal = null;
    this.freeDeliverySuccessModal = null;
    // authen
    this.otpModal = null;
    //other
    this.productDescriptionModal = null;
    this.pointSummaryModal = null;
    this.skipModal = null;
    this.pointCollectionStepModal = null;
    this.welcomePointModal = null;
    this.pointCollectionModal = null;
    this.alertRegisterModal = null;
    this.termModal = null;
    this.missionSuccessModal = null;
    this.missionCheckinSuccessModal = null;
    this.cancelMemberModal = null;
    this.marketingModal = null;
    this.privacySettingModal = null;
    this.copyPersonalModal = null;
    this.termsRegisterModal = null;
    this.privacyRegisterModal = null;
    this.ageConsentAlertModal = null;
    this.reConsentMarketingModal = null;
    this.termsReConsentModal = null;
    this.privacyReConsentModal = null;
    this.leaderBoardConditionModal = null;
    this.welcomeCouponModal = null;

    this.getModalController = function() {
        return this.modalController;
    };
    this.getAlertModal = function() {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };
    this.getConfirmModal = function() {
        this.confirmModal = new ConfirmModalController();
        this.modalController.setConfirmModal(this.confirmModal);
        return this.confirmModal;
    };

    this.getLoadingModal = function() {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };
    this.getSuccessModal = function() {
        this.successModal = new SuccessModalController();
        this.modalController.setSuccessModal(this.successModal);
        return this.successModal;
    };
    //#endregion generic

    //#region authen
    this.getOtpModalController = function() {
        this.otpModal = new OtpModalController();
        if (this.alertModal) {
            this.otpModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.otpModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setOtpModal(this.otpModal);
        return this.otpModal;
    };
    //#endregion authen

    //#region redeem
    this.getConfirmRedeemModal = function () {
        this.confirmRedeemModal = new ConfirmRedeemModalController();
        this.modalController.setConfirmRedeemModal(this.confirmRedeemModal);
        return this.confirmRedeemModal;
    };
    this.getDrawDeliveryModal = function () {
        this.drawDeliveryModal = new DrawDeliveryModalController();
        this.modalController.setDrawDeliveryModal(this.drawDeliveryModal);
        return this.drawDeliveryModal;
    };
    this.getDonateSuccessModal = function () {
        this.donateSuccessModal = new DonateSuccessModalController();
        this.modalController.setDonateSuccessModal(this.donateSuccessModal);
        return this.donateSuccessModal;
    };
    this.getSerialModal = function () {
        this.serialModal = new SerialModalController();

        if (this.alertModal) {
            this.serialModal.setAlertModal(this.alertModal);
        }

        this.modalController.setSerialModal(this.serialModal);
        return this.serialModal;
    };
    this.getShippingAddressModal = function () {
        this.shippingAddressModal = new ShippingAddressModalController();

        if (this.alertModal) {
            this.shippingAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.shippingAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setShippingAddressModal(this.shippingAddressModal);
        return this.shippingAddressModal;
    }
    this.getFreeDeliverySuccessModal = function () {
        this.freeDeliverySuccessModal = new FreeDeliverySuccessModalController();
        this.modalController.setFreeDeliverySuccessModal(this.freeDeliverySuccessModal);
        return this.freeDeliverySuccessModal;
    };
    this.getConfirmDeliveryAddressModal = function () {
        this.confirmDeliveryAddressModal = new ConfirmDeliveryAddressModalController();
        this.modalController.setConfirmDeliveryAddressModal(this.confirmDeliveryAddressModal);
        return this.confirmDeliveryAddressModal;
    }
    //#endregion redeem

    //#region custom modal

    this.getProductDescriptionModal = function () {
        this.productDescriptionModal = new ProductDescriptionModalController();
        this.modalController.setProductDescriptionModal(this.productDescriptionModal);
        return this.productDescriptionModal;
    };
    this.getPointSummaryModal = function () {
        this.pointSummaryModal = new PointSummaryModalController();
        this.modalController.setPointSummaryModal(this.pointSummaryModal);
        return this.pointSummaryModal;
    };
    this.getSkipModal = function () {
        this.skipModal = new SkipModalController();
        this.modalController.setSkipModal(this.skipModal);
        return this.skipModal;
    };
    this.getPointCollectionStepModal = function () {
        this.pointCollectionStepModal = new PointCollectionStepModalController();
        this.modalController.setPointCollectionStepModal(this.pointCollectionStepModal);
        return this.pointCollectionStepModal;
    };
    this.getWelcomeCouponModal = function () {
        this.welcomeCouponModal = new WelcomeCouponModalController();
        this.modalController.setWelcomeCouponModal(this.welcomeCouponModal);
        return this.welcomeCouponModal;
    }
    this.getWelcomePointModal = function () {
        this.welcomePointModal = new WelcomePointModalController();
        if (this.welcomeCouponModal) {
            this.welcomePointModal.setWelcomeCouponModal(this.welcomeCouponModal);
        }
        this.modalController.setWelcomePointModal(this.welcomePointModal);
        return this.welcomePointModal;
    }
    this.getPointCollectionModal = function () {
        this.pointCollectionModal =  new PointCollectionModalController();
        if (this.loadingModal) {
            this.pointCollectionModal.setLoadingModal(this.loadingModal);
        }
        if (this.pointSummaryModal) {
            this.pointCollectionModal.setPointSummaryModal(this.pointSummaryModal);
        }
        if (this.productDescriptionModal) {
            this.pointCollectionModal.setProductDescriptionModal(this.productDescriptionModal);
        }

        this.modalController.setPointCollectionModal(this.pointCollectionModal);
        return this.pointCollectionModal;
    };
    this.getAlertRegisterModal = function() {
        this.alertRegisterModal = new AlertRegisterModalController();
        this.modalController.setAlertRegisterModal(this.alertRegisterModal);
        return this.alertRegisterModal;
    };
    this.getTermModal = function() {
        this.termModal = new TermModalController();
        this.modalController.setTermModal(this.termModal);
        return this.termModal;
    };
    this.getMissionSuccessModal = function() {
        this.missionSuccessModal = new MissionSuccessModalController();
        this.modalController.setMissionSuccessModal(this.missionSuccessModal);
        return this.missionSuccessModal;
    }

    this.getMissionSuccessCheckinModal = function() {
        this.missionSuccessCheckinModal = new MissionSuccessCheckinModalController();
        this.modalController.setMissionSuccessCheckinModal(this.missionSuccessCheckinModal);
        return this.missionSuccessCheckinModal;
    } 
    
    this.getCancelMemberModal = function() {
        this.cancelMemberModal = new CancelMemberModalController();
        this.modalController.setCancelMemberModal(this.cancelMemberModal);
        return this.cancelMemberModal;
    }
    this.getMarketingModal = function() {
        this.marketingModal = new MarketingModalController();
        if (this.alertModal) {
            this.marketingModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.marketingModal.setLoadingModal(this.loadingModal);
        }
        this.modalController.setMarketingModal(this.marketingModal);
        return this.marketingModal;
    };
    this.getPrivacySettingModal = function() {
        this.privacySettingModal = new PrivacySettingModalController();
        if (this.termModal) {
            this.privacySettingModal.setTermModal(this.termModal);
        }
        if (this.marketingModal) {
            this.privacySettingModal.setMarketingModal(this.marketingModal);
        }
        if (this.copyPersonalModal) {
            this.privacySettingModal.setCopyPersonalModal(this.copyPersonalModal);
        }
        this.modalController.setPrivacySettingModal(this.privacySettingModal);
        return this.privacySettingModal;
    };
    this.getCopyPersonalModal = function() {
        this.copyPersonalModal = new CopyPersonalModalController();
        if (this.alertModal) {
            this.copyPersonalModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.copyPersonalModal.setLoadingModal(this.loadingModal);
        }
        this.modalController.setCopyPersonalModal(this.copyPersonalModal);
        return this.copyPersonalModal;
    }
    this.getTermsRegisterModal = function() {
        this.termsRegisterModal = new TermsRegisterModalController();
        this.modalController.setTermsRegisterModal(this.termsRegisterModal);
        return this.termsRegisterModal;
    };
    this.getPrivacyRegisterModal = function() {
        this.privacyRegisterModal = new PrivacyRegisterModalController();
        this.modalController.setPrivacyRegisterModal(this.privacyRegisterModal);
        return this.privacyRegisterModal;
    };
    this.getMarketingReConsentModal = function() {
        this.marketingReConsentModal = new MarketingReConsentModalController();
        if (this.alertModal) {
            this.marketingReConsentModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.marketingReConsentModal.setLoadingModal(this.loadingModal);
        }
        this.modalController.setMarketingReConsentModal(this.marketingReConsentModal);
        return this.marketingReConsentModal;
    };
    this.getTermsReConsentModal = function() {
        this.termsReConsentModal = new TermsReConsentModalController();
        this.modalController.setTermsReConsentModal(this.termsReConsentModal);
        return this.termsReConsentModal;
    };
    this.getPrivacyReConsentModal = function() {
        this.privacyReConsentModal = new PrivacyReConsentModalController();
        this.modalController.setPrivacyReConsentModal(this.privacyReConsentModal);
        return this.privacyReConsentModal;
    };
    this.getAgeConsentAlertModal = function() {
        this.ageConsentAlertModal = new AgeConsentAlertModalController();
        this.modalController.setAgeConsentAlertModal(this.ageConsentAlertModal);
        return this.ageConsentAlertModal;
    };
    this.getLeaderBoardConditionModal= function() {
        this.leaderBoardConditionModal = new LeaderBoardConditionModalController();
        this.modalController.setLeaderBoardConditionModal(this.leaderBoardConditionModal);
        return this.leaderBoardConditionModal;
    };
    
    //#endregion custom modal
}
